<ng-container [ngSwitch]="columnInfoDto.TextFieldTypeObject.FieldType">
  <ng-container *ngSwitchCase="ColumnFieldTypes.String">
    <ap-column-string [baseId]="baseId" [columnName]="columnName" [columnInfoDto]="columnInfoDto.TextFieldTypeObject" [dataItem]="dataItem"></ap-column-string>
  </ng-container>
  <ng-container *ngSwitchCase="ColumnFieldTypes.Number">
    <ap-column-number [baseId]="baseId" [columnName]="columnName" [columnInfoDto]="columnInfoDto.TextFieldTypeObject" [dataItem]="dataItem"></ap-column-number>
  </ng-container>
  <ng-container *ngSwitchCase="ColumnFieldTypes.Date">
    <ap-column-date [baseId]="baseId" [columnName]="columnName" [columnInfoDto]="columnInfoDto.TextFieldTypeObject" [dataItem]="dataItem"></ap-column-date>
  </ng-container>
  <ng-container *ngSwitchCase="ColumnFieldTypes.Html">
    <ap-column-html [baseId]="baseId" [columnName]="columnName" [columnInfoDto]="columnInfoDto.TextFieldTypeObject" [dataItem]="dataItem"></ap-column-html>
  </ng-container>
  <ng-container *ngSwitchCase="ColumnFieldTypes.TimeFrame">
    <ap-column-timeframe [baseId]="baseId" [columnName]="columnName" [columnInfoDto]="columnInfoDto.TextFieldTypeObject" [dataItem]="dataItem"></ap-column-timeframe>
  </ng-container>
  <ng-container *ngSwitchCase="ColumnFieldTypes.ExtTimeframe">
    <ap-column-ext-timeframe [baseId]="baseId" [columnName]="columnName" [columnInfoDto]="columnInfoDto.TextFieldTypeObject" [dataItem]="dataItem"></ap-column-ext-timeframe>
  </ng-container>
  <ng-container *ngSwitchCase="ColumnFieldTypes.ExtFindcontrol">
    <ap-column-ext-findcontrol [baseId]="baseId" [columnName]="columnName" [columnInfoDto]="columnInfoDto.TextFieldTypeObject" [dataItem]="dataItem"></ap-column-ext-findcontrol>
  </ng-container>
</ng-container>
